import React from "react";
import "./showDetails.css";
import { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { MovieDetailsContext } from "../../context/detailInfo";
import { MDBContainer, MDBRow } from "mdbreact";
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
  MDBCol,
  MDBView,
} from "mdbreact";
import Rating from "@material-ui/lab/Rating";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
const ShowDetails = (props) => {
  const {
    fetchDetailInfo,
    info,
    loading,
    recommendation,
    uKey,
    Ratings,
    imdb,
  } = useContext(MovieDetailsContext);
  const value = Ratings / 2;
  useEffect(() => {
    console.log("UseEffect Called");
    console.log(props.match.params.movieId);
    fetchDetailInfo(props.match.params.movieId);
  }, [props.match.params.movieId]);

  return (
    <MDBContainer>
      {info == null || loading === true ? (
        <h1>loading</h1>
      ) : (
        <MDBRow className="row">
          <MDBCol md="6">
            <img
              src={`https://image.tmdb.org/t/p/w300/${info.poster_path}`}
              className="imgDetailsPage img-fluid"
              alt=""
            />
          </MDBCol>
          <MDBCol md="6">
            <div className="div">
              <b>
                {" "}
                <h3>{info.title}</h3> Overview:
              </b>
              <div></div>
              {info.overview}
              <div></div>
              <div style={{ marginTop: "3%", marginBottom: "3%" }}>
                Release Date: {info.release_date}
              </div>
              <div className="Box">
                <Box component="fieldset" mb={3} borderColor="transparent">
                  <Typography component="legend">Ratings</Typography>
                  <Rating name="read-only" value={value} readOnly />
                </Box>
                <h6>IMDB Ratings: {imdb}</h6>
              </div>
              <div className="link" style={{ marginTop: "5%" }}>
                <h4>
                  {" "}
                  <a href={`https://www.youtube.com/watch?v=${uKey}`}>
                    <i class="fas fa-film"></i> Trailer
                  </a>
                </h4>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      )}
      <h5>Recommended: </h5>
      <div class="overflow-auto">
        <MDBRow>
          {recommendation.length === 0 ? (
            <h1>loading...</h1>
          ) : (
            recommendation.map((item, index) => (
              <MDBCol md="4" key={index}>
                <MDBCard style={{ marginTop: "30px" }}>
                  <MDBCardImage
                    style={{ width: "100%" }}
                    src={`https://image.tmdb.org/t/p/w300/${item.poster_path}`}
                  />
                  <MDBCardBody>
                    <MDBCardTitle>
                      <h5>{item.title}</h5>
                    </MDBCardTitle>
                    <MDBCardText>
                      {item.overview.split("").splice(0, 50).join("")}....
                    </MDBCardText>
                    <div className="button">
                      {" "}
                      <Link to={`/details/${item.id}`}>
                        <h6>View More</h6>
                      </Link>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            ))
          )}
        </MDBRow>
      </div>
    </MDBContainer>
  );
};

export default ShowDetails;
